const automations = {
  // ─── Hub header ───
  hubTitle: "מרכז אוטומציות",
  liveRegistry: "רישום חי",
  // ─── Quick actions ───
  quickActions: "פעולות מהירות",
  runOrigamiSync: "סנכרון Origami",
  openN8n: "פתח n8n",
  testHealth: "בדיקת תקינות",
  sendTestNotification: "שלח התראת בדיקה",
  running: "מריץ...",
  actionSuccess: "הצלחה",
  actionError: "שגיאה",
  // ─── Connection cards ───
  connections: "חיבורים",
  online: "מחובר",
  offline: "לא מחובר",
  configured: "מוגדר",
  unconfigured: "לא מוגדר",
  lastChecked: "בדיקה אחרונה",
  testConnection: "בדוק",
  checking: "בודק...",
  supabase: "Supabase",
  supabaseDesc: "בסיס נתונים, אימות ו-Realtime",
  n8n: "n8n",
  n8nDesc: "מנוע זרימות עבודה",
  origami: "Origami CRM",
  origamiDesc: "מערכת תפעול — מקור אמת",
  wati: "WATI WhatsApp",
  watiDesc: "הודעות ותקשורת לקוחות",
  notion: "Notion",
  notionDesc: "משימות, מפרטים ומפת דרכים",
  // ─── Tabs ───
  tabEndpoints: "נקודות קצה",
  tabJobs: "משימות מתוזמנות",
  tabWebhooks: "Webhooks",
  tabSuggestions: "הצעות",
  tabRssFeeds: "RSS",
  // ─── API Endpoints panel ───
  apiEndpoints: "נקודות קצה API",
  apiEndpointsDesc: "כל הנתיבים הפעילים במערכת",
  method: "מתודה",
  path: "נתיב",
  auth: "אימות",
  authPublic: "ציבורי",
  authRequired: "נדרש JWT",
  authAdmin: "מנהל",
  tryIt: "בדוק",
  // ─── Scheduled Jobs panel ───
  scheduledJobs: "משימות מתוזמנות",
  scheduledJobsDesc: "pg_cron ו-n8n workflows",
  pgCronJobs: "משימות pg_cron",
  jobName: "שם משימה",
  schedule: "תזמון",
  status: "סטטוס",
  active: "פעיל",
  paused: "מושהה",
  runNow: "הרץ עכשיו",
  n8nWorkflows: "זרימות n8n",
  n8nOpenDashboard: "פתח לוח n8n",
  n8nConfigureUrl: "הגדר כתובת n8n ב-environment variables",
  cleanNotifications: "ניקוי התראות ישנות",
  cleanNotificationsSchedule: "כל יום בחצות",
  weeklyRecurringTasks: "משימות חוזרות שבועיות",
  weeklyRecurringSchedule: "כל יום ראשון 08:00",
  origamiSync: "סנכרון Origami",
  origamiSyncSchedule: "כל שעה",
  // ─── Webhooks panel ───
  webhooks: "Webhooks נכנסים",
  webhooksDesc: "נקודות קצה שמקבלות מידע ממערכות חיצוניות",
  source: "מקור",
  purpose: "מטרה",
  copyUrl: "העתק URL",
  copied: "הועתק!",
  showPayload: "הצג דוגמת Payload",
  hidePayload: "הסתר",
  origamiSyncPurpose: "סנכרון פרויקטים מ-Origami",
  origamiEntitiesPurpose: "סנכרון ישויות מ-Origami",
  pushSubscribePurpose: "הרשמת דפדפן להתראות Push",
  contractorSubmitPurpose: "הגשת טופס קבלן חדש",
  // ─── Suggestions panel ───
  suggestions: "הצעות לאוטומציה",
  suggestionsDesc: "דברים שאפשר לבצע אוטומטית — אבל עדיין לא מחוברים",
  difficulty: "קושי",
  impact: "השפעה",
  easy: "קל",
  medium: "בינוני",
  hard: "מורכב",
  high: "גבוהה",
  low: "נמוכה",
  learnMore: "מידע נוסף",
  collapse: "סגור",
  sug1Title: "סנכרון אוטומטי של Origami לפי לוח זמנים",
  sug1Desc: "pg_cron קורא ל-/api/origami/sync כל שעה — בלי n8n",
  sug1Steps: "1. הפעל pg_cron extension\n2. צור job שקורא ל-API route\n3. וודא שה-API key מוגדר",
  sug2Title: "התראת WhatsApp על שינוי סטטוס פרויקט",
  sug2Desc: "DB trigger + WATI API — הודעה אוטומטית ללקוח",
  sug2Steps: "1. צור DB trigger על טבלת projects\n2. כשסטטוס משתנה → שלח ל-WATI API\n3. הגדר template ב-WATI dashboard",
  sug3Title: "דוח שבועי במייל",
  sug3Desc: "pg_cron + Edge Function — סיכום פעילות כל יום ראשון",
  sug3Steps: "1. צור Edge Function שמרכזת סטטיסטיקות\n2. תזמן עם pg_cron כל יום ראשון 08:00\n3. שלח דרך Resend/SendGrid",
  sug4Title: "יצירת משימות אוטומטית מ-Notion",
  sug4Desc: "n8n workflow — כשנוספת משימה ב-Notion, היא נוצרת גם במערכת",
  sug4Steps: "1. חבר Notion trigger ב-n8n\n2. מפה את השדות לטבלת tasks\n3. הפעל את ה-workflow",
  sug5Title: "גיבוי לילי של בסיס הנתונים",
  sug5Desc: "pg_cron — snapshot יומי לטבלת גיבויים",
  sug5Steps: "1. צור טבלת db_backups\n2. pg_cron job כל לילה 02:00\n3. שמור metadata של הגיבוי",
  sug6Title: "לוג שינויים לישויות",
  sug6Desc: "DB trigger — כל שינוי בישות נרשם אוטומטית",
  sug6Steps: "1. צור טבלת entity_audit_log\n2. trigger על INSERT/UPDATE/DELETE\n3. שמור old_value, new_value, user_id",
  // ─── Activity + Run History tabs ───
  tabActivity: "פעילות",
  tabRunHistory: "היסטוריית הרצות",
  // ─── Activity feed ───
  activityFeed: "פיד פעילות",
  activityFeedDesc: "שינויים אחרונים במערכת — בזמן אמת",
  activityTable: "טבלה",
  activityAction: "פעולה",
  activityRecord: "רשומה",
  activityUser: "משתמש",
  activityTime: "זמן",
  activityInsert: "הוספה",
  activityUpdate: "עדכון",
  activityDelete: "מחיקה",
  activityNoEntries: "אין פעילות עדיין",
  activityLive: "חי",
  // ─── Run history ───
  runHistory: "היסטוריית הרצות",
  runHistoryDesc: "כל הריצות הידניות והאוטומטיות",
  runJobName: "שם ג'וב",
  runStatus: "סטטוס",
  runDuration: "משך",
  runTriggeredBy: "הופעל ע\"י",
  runStarted: "התחלה",
  runStatusRunning: "רץ",
  runStatusSuccess: "הצלחה",
  runStatusError: "שגיאה",
  runNoEntries: "אין הרצות עדיין",
  runLive: "חי",
  runMs: "מ\"ש",
  // ─── Cron history ───
  lastRun: "ריצה אחרונה",
  lastRunNever: "טרם רץ",
  lastRunStatus: "סטטוס ריצה אחרונה",
} as const;
export default automations;
